import React from 'react';
import { styled } from '@teko/ui';

const StyledBar = styled.div(({ barHeight, barBorder }) => `
  height: ${barHeight}px;
  border-radius: ${barBorder}px;
  background-color: #d2d2d2;
  margin-left: 8px;
  position: relative;
`);
const Progress = styled.div(({ height, border, progressPercentage, theme, color }) => {
  return `
  background-color: ${color || (theme == null ? void 0 : theme.brand.primary)};
  position: absolute;
  z-index: 1;
  height: inherit;
  border-radius: ${border}px;
  height: ${height}px;
  width: ${progressPercentage}%;
`;
});
const ProgressBar = ({
  progress = 0,
  barColor,
  barHeight = 4,
  barBorder = 2
}) => {
  return /* @__PURE__ */ React.createElement(StyledBar, {
    barHeight,
    barBorder
  }, /* @__PURE__ */ React.createElement(Progress, {
    progressPercentage: progress,
    color: barColor,
    height: barHeight,
    border: barBorder
  }));
};

export { ProgressBar };
